import React from "react";
import { Box, Container, Typography } from "@mui/material";
import BenefitsComparison from "./BenefitsComparison";
import { useParams } from "react-router-dom";

const BenefitsPage = () => {
  const { userId } = useParams();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 2 }}>
        <BenefitsComparison variant="page" userId={userId} />
      </Box>
    </Container>
  );
};

export default BenefitsPage;
